export const rosterRoleValues = ['regular', 'designated_substitute'] as const;

export type RosterRole = (typeof rosterRoleValues)[number];

export const rosterRoleLabels: Record<RosterRole, string> = {
  regular: 'Regular Player',
  designated_substitute: 'Designated Substitute',
};

export const rosterRoleOptions: Array<{ value: RosterRole; label: string }> = rosterRoleValues.map((value) => ({
  value,
  label: rosterRoleLabels[value],
}));

export type RosterRoleLike = {
  roster_role?: string | null;
};

export function normalizeRosterRole(value?: string | null): RosterRole {
  return value === 'designated_substitute' ? 'designated_substitute' : 'regular';
}

export function isDesignatedSubstitute(roster?: RosterRoleLike | null): boolean {
  return normalizeRosterRole(roster?.roster_role) === 'designated_substitute';
}

export function isRegularRosterPlayer(roster?: RosterRoleLike | null): boolean {
  return !isDesignatedSubstitute(roster);
}
